import { createContext, useContext, type ReactNode } from 'react'
import type { WebSocketConfig } from './websocket'

const WebSocketConfigContext = createContext<WebSocketConfig>({})

export function WebSocketConfigProvider({
  config,
  children,
}: {
  config: WebSocketConfig
  children: ReactNode
}) {
  return (
    <WebSocketConfigContext.Provider value={config}>
      {children}
    </WebSocketConfigContext.Provider>
  )
}

export function useWebSocketConfig(): WebSocketConfig {
  return useContext(WebSocketConfigContext)
}
